import { onlineManager } from "@tanstack/react-query";

export const TILE_POLLING_INTERVAL_MS = 2000;

/** Poll for new tiles only while online and the field has none yet. */
export function fieldTileRefetchInterval(
  field: { tiles?: string[] } | undefined
): number | false {
  if (!onlineManager.isOnline()) {
    return false;
  }
  if (field && (!field.tiles || field.tiles.length === 0)) {
    return TILE_POLLING_INTERVAL_MS;
  }
  return false;
}
